import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAgo',
  standalone: false
})
export class DateAgoPipe implements PipeTransform {

  transform(value: Date | string): string {
    if (!value) {
      return '';
    }

    if (!(value instanceof Date)) {
      value = new Date(value);
    }

    const now = new Date();
    const days = Math.round(Math.abs((now.getTime() - value.getTime()) / (1000 * 3600 * 24)));

    const weeks = Math.round(days / 7);
    const months = Math.round(days / 30);
    const years = Math.round(days / 365);

    if (!this.hasMidnightPassed(value)) {
      return 'Today';
    } else if (days < 1) {
      return '1 Day';
    } else if (days < 7) {
      return days + ' Day' + this.pluralize(days);
    } else if (weeks < 4) {
      return weeks + ' Week' + this.pluralize(weeks);
    } else if (months < 12) {
      return months + ' Month' + this.pluralize(months);
    } else {
      return years + ' Year' + this.pluralize(years);
    }
  }

  pluralize(number: number) {
    return number > 1 ? 's' : '';
  }

  hasMidnightPassed(date: Date) {
    const now = new Date();
    return now.getDate() !== date.getDate() ||
      now.getMonth() !== date.getMonth() ||
      now.getFullYear() !== date.getFullYear();
  }
}
